import React, { createElement } from 'react'

//Node Modules
import { domToReact, DomElement } from 'html-react-parser'

//Components
import CASSyntax from 'components/xis/CASSyntax'

export default ({ attribs, children }:DomElement, params:any, options:any) => {
  const id = (attribs && attribs['id']) || ''
  const language = id.replace('-syntax', '')

  return createElement(
    CASSyntax as React.FunctionComponent,
    { language } as any,
    domToReact(children as any, options)
  )
}